import { render } from "./EditChapterModal.vue?vue&type=template&id=4f07346d&scoped=true"
import script from "./EditChapterModal.vue?vue&type=script&lang=js"
export * from "./EditChapterModal.vue?vue&type=script&lang=js"

import "./EditChapterModal.vue?vue&type=style&index=0&id=4f07346d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f07346d"]])

export default __exports__